import styled from 'styled-components'
import { mediaQueries } from '../../providers/MediaQueryProvider'
import { breakpoints } from '../../providers/MediaQueryProvider/consts'

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  background: var(--color-black-alpha-1500);
  opacity: 0.8;

  ${mediaQueries.tablet} {
    display: none;
  }
`

export const BottomInset = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  height: 50px;
  top: 100%;
  background: var(--bg-primary);

  ${mediaQueries.tablet} {
    display: none;
  }
`

export const WrapperMobile = styled.div`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;

  @media (max-width: ${breakpoints.tablet}px) {
    display: block;
  }
`

export const WrapperDesktop = styled.div`
  display: block;
  @media (max-width: ${breakpoints.tablet}px) {
    display: none;
  }
`

export const Panel = styled.div`
  @media (max-width: ${breakpoints.tablet}px) {
    // We need to override popper positioning styles
    bottom: 0;
    left: 0;
    right: 0;
    position: fixed !important;
    width: 100% !important;
    transform: translate3d(0px, 0px, 0px) !important;
    inset: auto 0 0 0 !important;
  }
`
